<div class="row admin_grid_topgutter grid_top_margin" id="">
  <div class="col-12 col-md-4 position-relative">
    <input type="text"class="form-control form-control-sm"placeholder="Search..."(ngModelChange)="searchChange($event)"[ngModel]="searchText"/>
    <div *ngIf="searching" class="position-absolute top-50 end-0 translate-middle-y me-2" style="width: 2rem; height: 1rem;">
      <div class="spinner-border spinner-border-sm text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-8 text-end">
    <button class="btn btn-sm btn-dark me-1" (click)="zoomIn()" alt="Zoom In" title="Zoom In"><i class="fas fa-fw fa-search-plus"></i></button>
    <button class="btn btn-sm btn-dark me-1" (click)="resetZoom()" alt="Reset Zoom" title="Reset Zoom"><i class="fas fa-fw fa-search"></i></button>
    <button class="btn btn-sm btn-dark me-1" (click)="zoomOut()" alt="Zoom Out" title="Zoom Out"><i class="fas fa-fw fa-search-minus"></i></button>
    <button class="btn btn-sm btn-dark me-1" (click)="exportToCSV()" alt="Export CSV" title="Export CSV"><i class="fas fa-fw fa-file-csv"></i></button>
    <button class="btn btn-sm btn-dark me-1" (click)="exportToPDF()" alt="Export PDF" title="Export PDF"><i class="fas fa-fw fa-file-pdf"></i></button>
    <!--<button class="btn btn-sm btn-dark me-1" (click)="showRowGroups()"><i class="fas fa-fw fa-search-plus me-2"></i>Toggle Groups</button>-->
    <button class="btn btn-sm btn-dark" (click)="showSchema()" alt="Toggle Schema View" title="Toggle Schema View"><i class="fas fa-fw fa-arrows-rotate"></i></button>
    <!-- <button class="export-button"(click)="">Export to Weekly Report</button> -->
  </div>
</div>
<div class="row mt-2">
  <div class="col-12">
    <div style="height:66vh">
      <ag-grid-angular class="ag-theme-alpine"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [getRowStyle]="getRowStyle"
                       [sideBar]="false"
                       [suppressAggFuncInHeader]="false"
                       [suppressContextMenu]="false"
                       [groupIncludeFooter]="true"
                       [groupIncludeTotalFooter]="false"
                       [rowHeight]="28"
                       [headerHeight]="32"
                       [groupRowRendererParams]="groupRowRendererParams"
                       [stopEditingWhenCellsLoseFocus]="true"
                       (gridReady)="onGridReady($event)"
                       [rowGroupPanelShow]="'never'"
                       (cellEditingStarted)="onCellEditingStarted($event)"
                       (cellEditingStopped)="onCellEditingStopped($event)"
                       (cellValueChanged)="onCellValueChanged($event)"
                       style="width:100%;height:100%"
                       (refreshGrid)="refreshGrid($event)"
                       [isExternalFilterPresent]="isExternalFilterPresent.bind(this)"
                       [doesExternalFilterPass]="doesExternalFilterPass.bind(this)">
      </ag-grid-angular>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-12 text-end">
    <button class="btn btn-dark btn-sm me-1" (click)="saveChanges()">
      <i class="fas fa-fw fa-save me-2"></i>Save Changes
    </button>
  </div>
</div>
<div class="backdrop" [ngStyle]="{'display':showModal}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':showModal}" id="bootstrapModal">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-9">
              <span class="modal-title">
              </span>
            </div>
            <div class="col-12 col-md-3 text-end">
              <button type="button" class="btn btn-dark btn-sm" (click)="closeModal()" aria-label="Close">
                <i class="fas fa-fw fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
      </div>
      <div class="modal-footer text-end d-none">
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">
          <i class="fas fa-fw fa-times" alt="Close" title="Close"></i>
        </button>
      </div>
    </div>
  </div>
</div>
